import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import OfferSection from "./components/OfferSection";
import Marquee from "./components/Marquee";
import Destinations from "./components/Destinations";
import HowItWorks from "./components/HowItWorks";
import WhyCCPL from "./components/WhyCCPL";
import Testimonials from "./components/Testimonials";
import MidCTA from "./components/MidCTA";
import ApplyForm from "./components/ApplyForm";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import MobileBottomBar from "./components/MobileBottomBar";

const Landing = () => {
  return (
    <div className="App min-h-screen bg-[#0b1220] text-slate-100 pb-20 lg:pb-0">
      <Header />
      <main>
        <Hero />
        <OfferSection />
        <Marquee />
        <Destinations />
        <HowItWorks />
        <WhyCCPL />
        <Testimonials />
        <MidCTA />
        <ApplyForm />
        <Faq />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <MobileBottomBar />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
